<script setup>
import nextIcon from "@/assets/images/products/disabled-next.png"
import prevIcon from "@/assets/images/products/disabled-prev.png"
import { watch, defineProps, ref, defineEmits, toRefs, onMounted } from "vue";
const props = defineProps({
    groupList: {
        type: Array,
        required: true,
        default: () => [],
    },
    current_tab: {
        type: String,
        required: true,
        default: '',
    },
    tabKey: {
        type: String,
        required: true,
        default: '',
    },
    currentTabLang:{
        type: Number,
        required: true,
        default: 1,
    },
})
const activeTabId = ref(0) // current dom

const emits = defineEmits(['update:current_tab', 'onActiveTabId'])
const { groupList, tabKey, current_tab, currentTabLang } = toRefs(props)
const showBtn = ref(false) // 显示左右按钮
const current_tab1 = ref('')
//methods
const handlerToggleTab = (i) => {
    // 切换tab
    current_tab1.value = i;
    emits('update:current_tab', current_tab1.value)
    emits('onActiveTabId', current_tab1.value)
}

const prev = () => {
    //上一个
    if (activeTabId.value === 0) {
        activeTabId.value = groupList.value.length - 1
    } else {
        activeTabId.value--
    }
}

const next = () => {
    //下一个
    if (activeTabId.value === groupList.value.length - 1) {
        activeTabId.value = 0
    } else {
        activeTabId.value++
    }
}

const scrollToElement = (elementId) => {
    //定位到该元素
    const element = document.getElementById(elementId);
    if (element) {
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
        });
    }
}

const isScrollable = (elementId) => {
    // 判断元素是否可横向滚动
    const element = document.getElementById(elementId);
    // console.log(element.scrollWidth > element.clientWidth);
    return element.scrollWidth > element.clientWidth;
}

onMounted(() => {
    if (groupList.value.length){
        showBtn.value = isScrollable(tabKey.value)
    }
        
})

watch(activeTabId, (val) => {
    scrollToElement(`${tabKey.value}-${val}`)
})


watch(current_tab, (val) => {
    current_tab1.value = val;
}, { immediate: true });


</script>
<template>
    <div class="swiperTab d-flex align-items-center" v-if="groupList.length">
        <div style="width: 14px; display: inline-block;" v-if="showBtn">
            <img :src="prevIcon" style="width: 16px; height: auto;" @click="prev" class="cursor-pointer">
        </div>
        <ul class="nav nav-tabs nav-tabs-custom nav-success py-0 flex-1 my-scroll-bar" role="tablist" :id="tabKey"
            style="display: block; border-bottom: 1px solid #E9EBEC;overflow-x: auto; overflow-y: hidden;
            box-sizing: border-box; margin: 0 auto; padding: 0; white-space: nowrap; flex: 1;">
            <li class="nav-item" v-for="(tab, i) in groupList" :key="i" :id="`${tabKey}-${i}`"
                style="display: inline-block;" :class="activeTabId == i && showBtn ? 'activeLi' : ''">
                <a :class="[
                    'nav-link',
                    'All',
                    'py-2',
                    'position-relative cursor',
                    tab.id == current_tab1 && 'active',
                ]" @click="handlerToggleTab(tab.id)">{{ currentTabLang ==1? tab.name: tab.name_en }}</a>
            </li>
        </ul>
        <div style="width:14px;display: inline-block; text-align: right;" v-if="showBtn">
            <img :src="nextIcon" style="width: 16px; height: auto;" @click="next" class="cursor-pointer">
        </div>
    </div>
</template>
<style scoped lang="scss">
.swiperTab {
    .nav-success.nav-tabs-custom .nav-link {
        color: #212529;
        font-size: 13px;
        font-weight: 400;
    }

    .nav-success.nav-tabs-custom .nav-link.active::after {
        background-color: #0AB39c;
    }

    .activeLi {
        a {
            color: #51b09d !important;
        }
    }

    .nav-tabs-custom .nav-item .nav-link::after {
        bottom: 1px;
    }
}
</style>